<div
  class="bundle-portfolio-card"
  [class.open]="isOpen"
  [class.closed]="!isOpen"
  (click)="isOpen = !isOpen"
  *ngIf="getBundleTotalFiat() > 0"
>
  <div class="crypto-card">
    <div class="coin-info-section">
      <img class="coin-logo" [src]="'/assets/icons/crypto/bundles/' + ticker + '.svg'" />
      <div class="coin-name-section">
        <span class="coin-name">{{ name }} </span>
        <div>
          <span *ngFor="let coin of coins; let index = index" class="coin-ticker">
            {{ index == coins.length - 1 ? coin : coin + ', ' }}
          </span>
        </div>
      </div>
    </div>
    <div class="show-balances-section">
      <span>...</span>
    </div>

    <div class="coin-variance-section">
      <span
        class="variance"
        [class.grow]="variation > 0"
        [class.drop]="variation < 0"
        *ngIf="variation < 0 || variation === 0 || variation > 0"
      >
        {{ variation > 0 ? '+' : '' }}{{ variation | number: '0.2-2' }}%
      </span>
    </div>

    <div class="coin-balance-section">
      <div class="coin-balance-value">
        <span class="equivalent-ars" *ngIf="getBundleTotalFiat() !== 0"
          >≈
          {{ currency.replace('S', '$') }}
          {{ getBundleTotalFiat() | formatCoinAmount: currency }}</span
        >
      </div>
    </div>
  </div>
  <div class="coins-balance-section">
    <app-crypto-balance
      *ngFor="let balance of cryptoBalances"
      [balance]="balance"
      [intoBundle]="true"
      [equivalentInArs]="currency === 'ARS' ? true : false"
    >
    </app-crypto-balance>
  </div>
</div>
